
export default {
  getPrograms () {
    const c = [
      { name: 'Cub Scouting', id: 'CubScouting' },
      { name: 'Scouts BSA', id: 'ScoutsBSA' },
      { name: 'Venturing', id: 'Venturing' },
      { name: 'Sea Scouting', id: 'SeaScouting' },
      { name: 'Exploring', id: 'Exploring' },
      { name: 'District', id: 'District' },
      { name: 'Council', id: 'Council' },
      { name: 'Other', id: 'Other' }
    ]
    return c
  }
}
